import React from 'react';
import {
  Box,
  Typography,
  Fade,
  useTheme,
  alpha
} from '@mui/material';
import {
  WavingHand,
  Person
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';

const WelcomeSection = () => {
  const { user } = useAuth();
  const theme = useTheme();

  // Função para determinar a saudação baseada no horário
  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour >= 0 && hour < 5) return 'Boa madrugada';
    if (hour >= 5 && hour < 12) return 'Bom dia';
    if (hour >= 12 && hour < 18) return 'Boa tarde';
    return 'Boa noite';
  };

  const getUserName = () => user?.name || 'Ouvinte';

  const getWelcomeMessage = () => {
    if (user && user.role === 'dj') {
      return 'Bem-vindo(a) de volta! Que tal tocar algo incrível hoje?';
    }
    return 'Aproveite nossa programação e participe do chat!';
  };

  return (
    <Fade in timeout={1000}>
      <Box
        sx={{
          mb: 0,
          px: 1,
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1.5,
            px: 3,
            py: 1,
            borderRadius: '50px',
            background: { xs: 'rgba(255, 255, 255, 0.06)', md: 'rgba(255, 255, 255, 0.03)' },
            backdropFilter: { xs: 'none', md: 'blur(10px)' },
            border: '1px solid rgba(255, 255, 255, 0.05)',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
            transition: 'all 0.3s ease',
            '&:hover': {
              background: 'rgba(255, 255, 255, 0.05)',
              borderColor: alpha(theme.palette.primary.main, 0.2),
              boxShadow: `0 4px 20px ${alpha(theme.palette.primary.main, 0.1)}`,
            }
          }}
        >
          {/* Icon/Emoji */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: '50%',
              background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.2)} 0%, ${alpha(theme.palette.secondary.main, 0.2)} 100%)`,
              color: theme.palette.primary.main,
            }}
          >
            <WavingHand sx={{ fontSize: '1.1rem' }} />
          </Box>

          {/* Main Text */}
          <Typography
            variant="body2"
            sx={{
              color: 'white',
              fontFamily: 'Orbitron, sans-serif',
              fontWeight: 600,
              fontSize: '0.85rem',
              letterSpacing: '0.5px',
              display: 'flex',
              alignItems: 'center',
              gap: 0.5
            }}
          >
            <span style={{ color: theme.palette.primary.main }}>{getGreeting()},</span>
            <span>{getUserName()}!</span>
          </Typography>

          {/* Separator */}
          <Box
            sx={{
              width: '1px',
              height: '14px',
              bgcolor: 'rgba(255, 255, 255, 0.1)',
              mx: 0.5
            }}
          />

          {/* Sub Message */}
          <Typography
            variant="caption"
            sx={{
              color: alpha('#fff', 0.6),
              fontFamily: 'Roboto, sans-serif',
              fontSize: '0.8rem',
              display: { xs: 'none', sm: 'block' }
            }}
          >
            {getWelcomeMessage()}
          </Typography>
        </Box>
      </Box>
    </Fade>
  );
};

export default WelcomeSection;
